export class ImageAccessUrlViewModel {
    url: string;
    expiresOn?: Date;
    isPrivate: boolean;
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/ImageAccessUrlViewModel.ts